import React from "react";
import { PALLET_STATUS_LABEL, PALLET_STATUS_STYLE } from "src/constants";
import { PalletStatus } from "src/types";

interface PalletStatusPillProps {
  status: PalletStatus;
  className?: string;
}

const PalletStatusPill: React.FC<PalletStatusPillProps> = ({ status, className }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium border ${PALLET_STATUS_STYLE[status] ?? ""} ${className ?? ""}`.trim()}
  >
    {PALLET_STATUS_LABEL[status] ?? status}
  </span>
);

export { PalletStatusPill };
